import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router";
import { BindableFormCheck } from "../components/BindableFormCheck";
import { LoadingComponent } from "../components/LoadingComponent";
import { SimpleFormField } from "../components/SimpleFormField";
import { getDB } from "../util/db";
import { useProfile } from "../components/ProfileContext.js";
import { ComponentType } from "../models/ComponentType";
import { setNavAdvisoryLockout } from "../util/utils";

export function ComponentTypePage(props) {
	setNavAdvisoryLockout(true);

	let params = useParams();
	let ctypeId = params.componentTypeId;
	let [ctype, setCtype] = useState(ctypeId == "new" ? {} : null);
	let [profile] = useProfile();
	let navigate = useNavigate();

	let isLoading = (ctype == null);
	useEffect(async () => {
		if(isLoading) {
			let db = await getDB();
			setCtype(await db.get("ComponentTypes", ctypeId));
		}
	});

	let saveAction = async () => {
		try {
			await ComponentType.saveComponentType(ctype, profile);
			navigate("/componentTypes");
		} catch(err) {
			alert(`Unable to save component type: ${err}`);
		}
	};

	let deleteAction = async() => {
		if(!confirm("Are you sure you want to delete this component type?")) {
			return;
		}
		try {
			await ComponentType.deleteComponentType(ctype, profile);
			navigate("/componentTypes");
		} catch(err) {
			alert(`Unable to delete component type: ${err}`);
		}
	}

	if(isLoading) {
		return <LoadingComponent />;
	}

	return <div>
		<h1>Edit Component Type</h1>
		<SimpleFormField label="Component Type" bindObject={ctype} bindAttribute="name" />
		<BindableFormCheck label="Has Serial Number" bindObject={ctype} bindAttribute="hasSerialNumber" />
		<BindableFormCheck label="Has Model Number" bindObject={ctype} bindAttribute="hasModelNumber" />
		<BindableFormCheck label="Has Asset Number" bindObject={ctype} bindAttribute="hasAssetNumber" />
		<Button onClick={saveAction} className="m-2">Save</Button>
		<Button variant="danger" onClick={deleteAction} className="m-2">Delete</Button>
	</div>;
} 